// extracted by mini-css-extract-plugin
module.exports = {"bundles":"TabBundles_bundles__zCZKv"};